import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
export default Vue.extend({
    data: () => ({
        loading: false,
        success: false,
        error: '',
    }),
    computed: {
        ...mapGetters('accountLookup', ['token']),
    },
    methods: {
        ...mapActions('accountLookup', ['changePrivateEmail']),
        setError(error) {
            this.error = error || 'Something went wrong';
        },
        async changePersonalEmail(email, token) {
            var _a, _b;
            try {
                this.loading = true;
                this.success = false;
                this.error = '';
                const res = await this.changePrivateEmail({
                    token: token || this.token,
                    email,
                });
                if (res.error) {
                    this.$emit('error');
                    this.setError((_a = res.error) === null || _a === void 0 ? void 0 : _a.message);
                }
                else if (res.data) {
                    this.$emit('success');
                    this.success = true;
                }
                return res;
            }
            catch (e) {
                this.$emit('error');
                this.setError(((_b = e.response.data.error) === null || _b === void 0 ? void 0 : _b.message) || e.message);
                return e.response;
            }
            finally {
                this.loading = false;
            }
        },
    },
});
